import React, { useEffect, useState } from 'react';

interface IHoneyCheckProps {
  addressHoney: number;
  requiredHoney: number;
  callback: (...args: any[]) => void | Promise<void>;
  callBackArgs: any;
  trigger: React.ReactNode;
  claim?: boolean;
}

const countDecimals = (number: number) => {
  if (number === undefined || number === null) return 0;
  if (Math.floor(number) === number) return 0;
  return number.toString().split('.')[1]?.length || 0;
};

const convertHoneyBalance = (honey: number) => honey; // TODO: Replace with actual conversion if needed

const HoneyCostPopup: React.FC<IHoneyCheckProps> = (props) => {
  const [open, setOpen] = useState(false);
  const [hasEnough, setHasEnough] = useState<null | boolean>(null);

  useEffect(() => {
    if (props.claim === true) {
      setHasEnough(true);
    } else {
      let addyHoney = Number(convertHoneyBalance(props.addressHoney));
      if (addyHoney < props.requiredHoney) {
        setHasEnough(false);
      } else if (addyHoney >= props.requiredHoney) {
        setHasEnough(true);
      }
    }
  }, [props.requiredHoney, props.addressHoney, props.claim]);

  return (
    <>
      <span onClick={() => setOpen(true)}>{props.trigger}</span>
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80">
          <div className="bg-black bg-opacity-95 rounded-md shadow-lg w-full max-w-lg p-6 relative border-2 border-[#c4f6f9] text-white">
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-white text-xl"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              ×
            </button>
            {hasEnough !== null && (
              <div>
                {!props.claim ? (
                  <div>
                    <h2 className="text-xl font-bold text-center text-[#c4f6f9] mb-4">
                      This transaction will <span className="text-[#ffa2f8]">burn $HONEYD</span>
                    </h2>
                    {hasEnough === true && (
                      <div className="text-center text-white text-sm mb-4">
                        This transaction will burn: <span className="text-[#ffa2f8]">{countDecimals(props.requiredHoney) > 2 ? props.requiredHoney.toFixed(2) : props.requiredHoney} $HONEYD</span>
                        <br />
                        Balance after transaction: <span className="text-[#fcd34d]">{countDecimals(Number(convertHoneyBalance(props.addressHoney)) - props.requiredHoney) > 2 ? (Number(convertHoneyBalance(props.addressHoney)) - props.requiredHoney).toFixed(2) : Number(convertHoneyBalance(props.addressHoney)) - props.requiredHoney} $HONEYD</span>
                      </div>
                    )}
                    {hasEnough === false && (
                      <div className="text-center text-white text-sm mb-4">
                        You need <span className="text-[#fcd34d]">{countDecimals(props.requiredHoney - Number(convertHoneyBalance(props.addressHoney))) > 2 ? (props.requiredHoney - Number(convertHoneyBalance(props.addressHoney))).toFixed(2) : props.requiredHoney - Number(convertHoneyBalance(props.addressHoney))}</span> additional <span className="text-[#fcd34d]">$HONEYD</span> to complete this transaction
                      </div>
                    )}
                  </div>
                ) : (
                  <div>
                    <h2 className="text-xl font-bold text-center text-[#c4f6f9] mb-4">
                      This transaction will <span className="text-[#fcd34d]">claim $HONEYD</span>
                    </h2>
                    <div className="text-center text-white text-sm mb-4">
                      This transaction will claim: <span className="text-[#fcd34d]">{countDecimals(props.requiredHoney) > 2 ? props.requiredHoney.toFixed(2) : props.requiredHoney} $HONEYD</span>
                      <br />
                      Balance after transaction: <span className="text-[#fcd34d]">{countDecimals(Number(convertHoneyBalance(props.addressHoney)) + props.requiredHoney) > 2 ? (Number(convertHoneyBalance(props.addressHoney)) + props.requiredHoney).toFixed(2) : Number(convertHoneyBalance(props.addressHoney)) + props.requiredHoney} $HONEYD</span>
                    </div>
                  </div>
                )}
              </div>
            )}
            {hasEnough !== null && (
              <div className="flex justify-center gap-4 mt-6">
                {hasEnough === true && (
                  <button
                    className="bg-transparent border-2 border-[#55bac3] text-[#55bac3] hover:bg-[#55bac3] hover:text-white text-sm py-2 px-6 rounded-md transition-colors"
                    onClick={async () => {
                      setOpen(false);
                      await props.callback(...props.callBackArgs);
                    }}
                  >
                    Confirm
                  </button>
                )}
                <button
                  className="bg-transparent border-2 border-gray-600 text-gray-400 hover:border-gray-500 hover:text-white text-sm py-2 px-6 rounded-md transition-colors"
                  onClick={() => setOpen(false)}
                >
                  {!hasEnough ? 'Close' : 'Cancel'}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default HoneyCostPopup;
